import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from "../../images/logo/Quick-Care.png";
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { getToken, clearToken } from '../../utils/tokenHelper';
import Star from '../../images/star.png'

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [profile, setProfile] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
        
    const navigate = useNavigate();
    
    useEffect(() => {
        const token = getToken();
        setIsLoggedIn(!!token);
    }, []);
    
    const handleButtonClick = () => {
        navigate(isLoggedIn ? '/trivia' : '/login');
    };

    useEffect(() => {
        const token = getToken(); // Get token from localStorage

        if (token) {
            setIsLoggedIn(true);

            // Fetch profile data
            const myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");
            myHeaders.append("Authorization", `Bearer ${token}`);

            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow",
            };

            fetch("https://api.quickcare.ng/api/v1/user/profile", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.success) {
                        setProfile(result.data);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching profile data:", error);
                });
        }
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleLogout = () => {
        clearToken();
        window.location.reload(); // Reload the page after clearing the token
    };

    const getInitials = () => {
        if (profile) {
            const { first_name, last_name } = profile;
            return `${first_name?.charAt(0)}${last_name?.charAt(0)}`;
        }
        return '';
    };

    return (
        <div className='flex items-center justify-between w-full p-4 raleway-font md:px-8 lg:px-16'>
            <Link to='/'>
                <img src={Logo} alt="Quick Care Logo" className='w-[150px] lg:w-[200px] h-[auto] mt-2 md:mt-0' />
            </Link>

            <div
                className={`md:flex gap-10 items-center font-medium ${
                    isMenuOpen
                        ? "absolute tracking-widest flex py-4 flex-col gap-1 top-20 left-0 w-full bg-[#069125] text-white"
                        : "hidden"
                }`}
            >
                {isLoggedIn ? (
                    <Link to='/triva' className='lg:text-[#3D3D3D]'>
                        Play Quiz
                    </Link>
                ) : (
                    <Link to='/login' className='lg:text-[#3D3D3D]'>
                        Play Quiz
                    </Link>
                )}
                <a href='#benefits'>Benefits</a>
                <a href='#about-us'>About Us</a>
            </div>

            <div className="flex items-center gap-4">
                {isLoggedIn ? (
                    <>
                        <Link to='/health' className='bg-[#069125] text-white font-medium px-3 py-2 rounded-lg hidden lg:block'>
                            Ask AI Doctor
                        </Link>
                        {profile && (
                            <button
                                onClick={toggleModal}
                                className="flex items-center justify-center w-10 h-10 text-white bg-gray-800 rounded-full"
                            >
                                {getInitials()}
                            </button>
                        )}
                    </>
                ) : (

                    <div className='hidden lg:flex gap-4'>
                        <Link to='/signup' className='border bg-white shadow-lg border-[#069125] text-[#069125] font-medium px-3 py-2 rounded-lg hover:bg-gray-100/70'>
                            Get Started
                        </Link>

                        {isLoggedIn ? (
                            <Link to='/triva' 
                            className='bg-gradient-to-b from-[#069125] to-[#6AEF88] flex items-center text-white font-medium px-4 py-2 rounded-lg gap-2'>
                                <img src={Star} alt="" />
                                <span>Play to Win Now </span>
                            </Link>
                        ) : (
                            <Link to='/login' 
                            className='bg-gradient-to-b from-[#069125] to-[#6AEF88] flex items-center text-white font-medium px-4 py-2 rounded-lg gap-2'>
                                <img src={Star} alt="" className='w-[23px] h-[17px]'/>
                                <span>Play to Win Now </span>
                            </Link>
                        )}

                        {/* <Link to='/signup' className='bg-[#069125]  text-white font-medium px-3 py-2 rounded-lg '>
                            Get Started
                        </Link> */}
                    </div>
                )}

                <div className='p-1 border border-black rounded md:hidden' onClick={toggleMenu}>
                    {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
                </div>
            </div>

            {isModalOpen && profile && (
                <div className="absolute z-50 p-4 bg-white rounded-md shadow-lg top-16 right-8">
                    <p className=""><span className='mr-1 font-medium'>Name:</span> {`${profile.first_name} ${profile.last_name}`}</p>
                    <p><span className='mr-1 font-medium'>Phone no:</span>+{profile.phone_number}</p>
                    <p>
                    <span className='mr-1 font-medium'>Subscription Status:{" "}</span>
                        
                        {profile.is_subscribed ? (
                            <span className="text-green-600">Subscribed</span>
                        ) : (
                            <span className="text-red-600">Not Subscribed</span>
                        )}
                    </p>
                    <p className='capitalize'><span className='mr-1 font-medium'>Country:</span> {profile.country}</p>
                    <button
                        onClick={handleLogout}
                        className="px-3 py-1 mt-2 text-white bg-red-500 rounded-md"
                    >
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
};

export default Navbar;
